import React from "react";
import { useTranslation } from "react-i18next";
import OTextArea from "../../components/reusable/OTextArea";

const JobDetailsStep = ({ register, errors, watch, permission, user }) => {
  const { t } = useTranslation();
  const req = watch?.("requirements") || "";
  const reqAr = watch?.("requirementsAr") || "";
  const resp = watch?.("responsibilities") || "";
  const respAr = watch?.("responsibilitiesAr") || "";

  const minLen = 30;

  return (
    <div className="grid md:grid-cols-1 gap-6">
      <div className="md:col-span-1">
        <OTextArea
          inputLabel={t("Requirements")}
          name="requirements"
          disabled={!(permission?.add || user?.role === "admin")}
          placeholder={t("Enter job requirements") || "Enter job requirements"}
          register={register("requirements", {
            required:
              t("Requirements are required") || "Requirements are required",
            minLength: {
              value: minLen,
              message:
                t("Please enter at least {{min}} characters", {
                  min: minLen,
                }) || `Please enter at least ${minLen} characters`,
            },
          })}
          errors={errors}
          requiredMark
        />
        <div className="text-xs text-gray-500">
          {req.length} {t("characters")}
        </div>
      </div>
      <div className="md:col-span-1">
        <OTextArea
          inputLabel={t("Requirements (Ar)")}
          name="requirementsAr"
          disabled={!(permission?.add || user?.role === "admin")}
          placeholder={
            t("Enter Arabic requirements") || "Enter Arabic requirements"
          }
          register={register("requirementsAr")}
          errors={errors}
        />
        <div className="text-xs text-gray-500">
          {reqAr.length} {t("characters")}
        </div>
      </div>
      <div className="md:col-span-1">
        <OTextArea
          inputLabel={t("Responsibilities")}
          name="responsibilities"
          disabled={!(permission?.add || user?.role === "admin")}
          placeholder={
            t("Enter job responsibilities") || "Enter job responsibilities"
          }
          register={register("responsibilities", {
            required:
              t("Responsibilities are required") ||
              "Responsibilities are required",
            minLength: {
              value: minLen,
              message:
                t("Please enter at least {{min}} characters", {
                  min: minLen,
                }) || `Please enter at least ${minLen} characters`,
            },
          })}
          errors={errors}
          requiredMark
        />
        <div className="text-xs text-gray-500">
          {resp.length} {t("characters")}
        </div>
      </div>
      <div className="md:col-span-1">
        <OTextArea
          inputLabel={t("Responsibilities (Ar)")}
          name="responsibilitiesAr"
          disabled={!(permission?.add || user?.role === "admin")}
          placeholder={
            t("Enter Arabic responsibilities") ||
            "Enter Arabic responsibilities"
          }
          register={register("responsibilitiesAr")}
          errors={errors}
        />
        <div className="text-xs text-gray-500">
          {respAr.length} {t("characters")}
        </div>
      </div>
    </div>
  );
};

JobDetailsStep.fields = ["requirements", "responsibilities"];

export default JobDetailsStep;
